import { ThemeProvider, createTheme } from '@mui/material'
import { Layout } from 'components/Layout/Layout'
import { useUser } from 'hooks/user'
import MainView from 'pages/Main/Main'
import VideoView from 'pages/Video/Video'
import RouteMarkingView from 'pages/RouteMarking/RouteMarking'
import NotFound from 'pages/NotFound/NotFound'
import Signin from 'pages/Signin/Signin/Signin'
import RestorePassword from 'pages/Signin/RestorePassword/RestorePassword'
import NewPassword from 'pages/Signin/NewPassword/NewPassword'
import PrintReport from 'pages/PrintReport/PrintReport'
import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'

import { PATH } from './utils/constants'

const theme = createTheme({
  palette: {
    primary: {
      main: '#2E70EF',
    },
    secondary: {
      main: '#000A19CC',
    },
  },
})

function PrivatePage({ children }: { children: JSX.Element }) {
  const user = useUser()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!user?.state.userLoggedIn) {
      const currentUrl = location.pathname + location.search
      const nextParam = encodeURIComponent(currentUrl)
      navigate(`${PATH.SIGNIN}?next=${nextParam}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.state.userLoggedIn])

  return children
}

function AuthPage({ children }: { children: JSX.Element }) {
  const location = useLocation()
  const user = useUser()

  if (user?.state.userLoggedIn) {
    const searchParams = new URLSearchParams(location.search)
    const nextUrl = searchParams.get('next')

    if (nextUrl) {
      try {
        const decodedUrl = decodeURIComponent(nextUrl)
        return <Navigate to={decodedUrl} replace />
      } catch (error) {
        // Если URL некорректный, перенаправляем на главную
        return <Navigate to={PATH.MAIN} replace />
      }
    }

    return <Navigate to={PATH.MAIN} state={{ from: location }} />
  }

  return children
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout.PublicPage />}>
            <Route path={PATH.SIGNIN} element={<AuthPage children={<Signin />} />} />
            <Route path={PATH.NOT_FOUND} element={<NotFound />} />
            <Route path={PATH.RESTORE_PASSWORD} element={<RestorePassword />} />
            <Route path={PATH.NEW_PASSWORD} element={<NewPassword />} />
          </Route>
          <Route element={<Layout.MainPage />}>
            <Route path={PATH.MAIN} element={<PrivatePage children={<MainView />} />} />
            <Route path={PATH.MAIN_PROJECT} element={<PrivatePage children={<MainView />} />} />
            <Route path={PATH.VIDEO} element={<PrivatePage children={<VideoView />} />} />
            <Route path={PATH.ROUTE_MARKING} element={<PrivatePage children={<RouteMarkingView />} />} />
          </Route>
          <Route path={PATH.PRINT_REPORT} element={<PrintReport />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
